module.exports = __webpack_public_path__ + "fonts/Rokkitt-Regular.woff";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Rokkitt/Rokkitt-Regular.woff
// module id = 3480
// module chunks = 0